"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJsonSuccess = void 0;
/**
 * Global axios config treats any status below 500 as a success (see bootstrap.js), so 4xx
 * responses arrive in .then() rather than .catch(). Their bodies are frequently not JSON at
 * all — a Cloudflare challenge page, a WordPress login redirect, an expired-session notice —
 * which means response.data is a string and every response.data.<key> read throws an opaque
 * TypeError that vanishes into the sibling catch block. Confirm the payload really is a JSON
 * object before trusting its shape.
 */
function isJsonSuccess(response) {
    return response.status < 400
        && response.data !== null
        && typeof response.data === 'object';
}
exports.isJsonSuccess = isJsonSuccess;
